<div class="question-body">
    <form [formGroup]="physicianForm">
        <div class="question-text">{{hasPhysicianLabel}}</div>
        <div class="container-fluid">
            <mat-radio-group formControlName="hasPhysicians" (change)="onRadioChange($event)">
                <mat-radio-button class="d-block" [disabled]="summaryMode" value="Yes"
                    [attr.data-test-value]="true">Yes</mat-radio-button>
                <mat-radio-button class="d-block" [disabled]="summaryMode" value="No"
                    [attr.data-test-value]="false">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="physicianForm.get('hasPhysicians').hasError('required')">required</mat-error>
        </div>
        <div *ngIf="hasPhysician" class="container-fluid">
            <div formArrayName="physcianDetails">
                <ng-container *ngFor="let control of physcianDetails.controls; let i = index; last as isLast">
                    <mat-card class="m-4" [formGroupName]="i">
                        <mat-card-content>
                            <div class="flex flex-column">
                                <div *ngIf="i == 0 && !primary">
                                    <span><u>Physician Details</u></span><br /><br />
                                </div>
                                <div *ngIf="i == 0 && primary">
                                    <span><u>Primary Care Details</u></span><br /><br />
                                </div>
                                <mat-form-field>
                                    <mat-label>Name of physician</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_name" type="text"
                                        formControlName="name" [disabled]="summaryMode" required />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Speciality</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_speciality"
                                        type="text" [disabled]="summaryMode" formControlName="speciality" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Address line (1)</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_address1" type="text"
                                        [disabled]="summaryMode" formControlName="addressLine1" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Address line (2)</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_address2" type="text"
                                        [disabled]="summaryMode" formControlName="addressLine2" />
                                </mat-form-field>
                                <div class="container-fluid"
                                    *ngIf="countries == null || countries.listItems.length == 0">
                                    <input class="form-control" name="{{name}}_physician_country" type="text"
                                        *ngIf="countries == null" [disabled]="summaryMode" formControlName="countryCode"
                                        required />
                                </div>
                                <div *ngIf="countries != null &&  countries.listItems.length > 0">
                                    <div>
                                        <mat-form-field class="w-100">
                                            <mat-label>Country</mat-label>
                                            <mat-select class="w-100" [name]="name + '_physician_country'"
                                                formControlName="countryCode" [disabled]="summaryMode" required>
                                                <mat-option *ngFor="let option of countries.listItems"
                                                    [value]="option.code">
                                                    {{option.description}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <mat-form-field class="w-100">
                                        <mat-label>State/Province</mat-label>
                                        <input matInput class="form-control" name="{{name}}_physician_state" type="text"
                                            [disabled]="summaryMode" formControlName="stateString" />
                                    </mat-form-field>
                                </div>
                                <mat-form-field>
                                    <mat-label>City</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_city" type="text"
                                        [disabled]="summaryMode" formControlName="city" required />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Zip</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_zip" type="text"
                                        [disabled]="summaryMode" formControlName="zip" />
                                </mat-form-field>

                                <mat-form-field>
                                    <mat-label>Phone</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_phone" type="text"
                                        [disabled]="summaryMode" formControlName="phone" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Fax</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_fax" type="text"
                                        [disabled]="summaryMode" formControlName="fax" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>E-mail</mat-label>
                                    <input matInput class="form-control" name="{{name}}_physician_email" type="text"
                                        [disabled]="summaryMode" formControlName="email" />
                                </mat-form-field>
                                <div class="flex flex-column" *ngIf="!primary">
                                    <div class="w-100">When did you last visit this physician for this condition?</div>
                                    <div class="flex last-visit-container">
                                        <mat-form-field class="last-visit-field  mr-2">
                                            <mat-label>Month</mat-label>
                                            <input matInput class="form-control"
                                                name="{{name}}_physician_last_check_month" type="text" placeholder="mm"
                                                formControlName="lastVisitMonth"
                                                [readonly]="physicianForm.get('physcianDetails').controls[i].controls['lastVisitDateExplicitlyUnknown'].value === true"
                                                minlength="2" maxlength="2" />
                                            <mat-error
                                                *ngIf="physicianForm.get('physcianDetails').controls[i].controls['lastVisitMonth'].hasError('required')">required</mat-error>
                                        </mat-form-field>
                                        <mat-form-field class="last-visit-field-middle">
                                            <mat-label>Year</mat-label>
                                            <input matInput class="form-control"
                                                name="{{name}}_physician_last_check_year" type="text" placeholder="yyyy"
                                                formControlName="lastVisitYear"
                                                [readonly]="physicianForm.get('physcianDetails').controls[i].controls['lastVisitDateExplicitlyUnknown'].value === true"
                                                minlength="4" maxlength="4" />
                                            <mat-error
                                                *ngIf="physicianForm.get('physcianDetails').controls[i].controls['lastVisitYear'].hasError('required')">required
                                                {{physicianForm.get('physcianDetails').controls[i].controls['lastVisitYear'].hasError('required')}}</mat-error>
                                        </mat-form-field>
                                        <mat-slide-toggle (change)="onUnknownChange($event, i)"
                                            labelPosition="before" class="last-visit-field-toggle d-inline-block"
                                            formControlName="lastVisitDateExplicitlyUnknown">
                                            <div>Unknown</div>
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                                <div class="flex flex-row" *ngIf="!summaryMode" style="padding-bottom: 20px">       
                                    <div class="flex-1"></div>      
                                    <div style="justify-content: flex-end">
                                        <mrs-btn-primary buttonLabel="Submit" buttonId="goHomeBtn" (onClick)="submit(i)" 
                                            [disabled]="!physicianForm.get('physcianDetails').controls[i]?.valid || !physicianForm.get('physcianDetails').controls[i]?.dirty"></mrs-btn-primary>
                                        <mrs-btn-tertiary buttonLabel="Remove" buttonId="removeButton" 
                                            *ngIf="physicianForm.get('physcianDetails').controls[i].get('uuid') !== ''"
                                            (onClick)="remove(i)"></mrs-btn-tertiary>
                                    </div>                       
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </ng-container>
            </div>
            <div *ngIf="physiciansValue.length > 0 && physiciansValue[0].uuid && physiciansValue[0].uuid !== null">
                <div>
                    <div class="question-text">Do you want to add another physician for this condition?
                    </div>
                    <div class="container-fluid">
                        <mrs-btn-primary buttonLabel="Add Physician" buttonId="addPhysicianBtn"
                            (onClick)="hasPhysicianAnswer(true)"></mrs-btn-primary>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>